export default {
  INIT_STATE: "agent/INIT_STATE",
  BOOKING_HISTORY_REQUEST: "agent/BOOKING_HISTORY_REQUEST",
  BOOKING_HISTORY_RESPONSE: "agent/BOOKING_HISTORY_RESPONSE",
  RETRIEVE_BOOKING_REQUEST: "agent/RETRIEVE_BOOKING_REQUEST",
  RETRIEVE_BOOKING_RESPONSE: "agent/RETRIEVE_BOOKING_RESPONSE",
  LAST_SEARCHED_BOOKING: "agent/LAST_SEARCHED_BOOKING",
  CHILD_AGENCIES_RESPONSE: 'agent/CHILD_AGENCIES_RESPONSE',
  REPORT_LIST_RESPONSE: 'agent/REPORT_LIST_RESPONSE',
}